import { Box, Typography } from "@mui/material";
import moment from "moment";
import { getUTCYMD } from "utils/timestamp.util";

const ListItem = ({
  data,
  isLast,
  details,
}: {
  data: any;
  isLast: boolean;
  details: any;
}) => {
  return (
    <Box sx={{ display: "flex", gap: "20px" }}>
      <img
        src={data?.listings?.images?.[0]?.preview_url}
        alt=""
        width="128"
        height="88"
        style={{ borderRadius: "8px", minWidth: "128px", maxWidth: "128px" }}
      />
      <Box
        sx={{
          borderBottom: isLast ? "1px solid #E2E2E2" : "",
          flex: 1,
          pb: "5px",

          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "30px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            {data?.listings?.listing_name}
          </Typography>
          <Typography
            sx={{
              lineHeight: "31px",
              color: "#6E8C20",
              fontWeight: 600,
              fontSize: "18px",
            }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(data?.listings?.price)}{" "}
            • {data?.delivery_type === 0 ? "Pickup" : "Delivery"}
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "34px",
            }}
          >
            Rental period:{" "}
            {moment(getUTCYMD(details?.from_date)).format("MMM DD")} -{" "}
            {moment(getUTCYMD(details?.to_date)).format("MMM DD")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ListItem;
